import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';

class GetAdditionalCharges extends Event {
    eventName = 'oms_getAdditionalCharges';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get Additional Charges
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
      
        data.endPoint = application_settings.endPoints.additionalCharges;
        data.method = 'POST';
        data.data = {
            client_id: clientId,
            order_currency:data.order_currency
        };
    
        this.sendRequest(data, function (response) {
            if (response) {
                //add data to storage
                let current_location = new LocalStorage.CurrentLocation(clientId).getData();
                let additionalCharges = new LocalStorage.AdditionalCharges(current_location);
                additionalCharges.setData(response);

                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });

    }
}

export default GetAdditionalCharges;